import { useMemo as u } from "react";
import { useIntlStore as m } from "@dcentralexpedientedigital/fe-shared/stores/intl-store";
import { getRoutePathById as n } from "../utils/get-route-path-by-id.js";
import { useConfig as s } from "./use-config.js";
function i(o) {
  const t = m((r) => r.locale), { pages: e } = s();
  return u(() => n({ id: o, pages: e, lang: t }), [o, t, e]);
}
export {
  i as usePageRoute
};
